import { createSelector } from '@reduxjs/toolkit';
import { getCurrentPopupStep, getInfoCardsPopupTexts } from "../blocks/infoCards/selectors";
export var getHeaderConfigText = createSelector([getCurrentPopupStep, getInfoCardsPopupTexts], function (popupStep, popupTexts) {
  if (!popupTexts[popupStep]) {
    return null;
  }
  var _ref = popupTexts[popupStep],
    backButtonText = _ref.backButtonText,
    headerText = _ref.headerText,
    subtitleText = _ref.subtitleText;
  return {
    backButtonText: backButtonText,
    headerText: headerText,
    subtitleText: subtitleText
  };
});